import {
  Box,
  Chip,
  TextField,
} from "@mui/material";
import React, { useState, useMemo } from "react";
import ReusableDataTable from "../../Component/DataTable/ReusableDataTablePrime";
import { FilterMatchMode } from "primereact/api";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/CommonSlice";
import { CustomMessage } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import AddIcon from "@mui/icons-material/Add";
import { ProjectMaster } from "../../types/assetTypes";
import { getProjectColumns } from "../../const/AssertData";
import { useEffect } from "react";
import { Typography } from "@mui/material";
import { MenuItem } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect';
import 'primereact/resources/themes/lara-light-blue/theme.css'; // ✅ Choose any theme you like
import 'primereact/resources/primereact.min.css';               // ✅ PrimeReact core
import 'primeicons/primeicons.css';                             // ✅ Icons used in dropdowns





import {
  getProjectById,
  getProjectMasterDataList,
  getLocalStoreMasterDataList,
  saveProject,
  getCountryAssetMasterDataList,
  getUsersMasterDataList,
} from "../../api/Services/masterServie";
import ReusablePrimeReactDialog from "../../Component/Dialog/ReusablePrimeReactDialog";
import { PAGESEND, PAGESTART } from "../../api/endpoint";
import { Dropdown } from 'primereact/dropdown';
import { RootState } from "../../store/Reduxstore";



interface ProjectProps {
  setPathname: (path: string) => void;
}

const Project: React.FC = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState<ProjectMaster[]>([]);
  const [pagination, setPagination] = useState({
    page: 1,
    rows: 13,
    totalRecords: 0,
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [projectData, setProjectData] = useState<ProjectMaster>({
    projectId: 0,
    projectName: "",
    status: "",

    userIds: []
  });

  // Memoized column definition
  const columns = useMemo(() => getProjectColumns(), []);

  if (columns.filter((val) => val.field === "action").length === 0) {
    columns.push({
      field: "action",
      header: "Action",
      sortable: false,
      filter: false,
      filterField: "action",
      filterPlaceholder: "Search",
      style: { minWidth: "12rem" },
      body: (rowData: any) => (
        <ReusablePrimeButton
          icon="pi pi-pencil"
          className="p-button-rounded p-button-outlined"
          onClick={() => handleEditFamilyAsset(rowData.projectId)}
        />
      ),
    });
  }



  const [filterData, setFilterData] = useState<Record<string, any>>(() =>
    (columns ?? []).reduce((acc, col) => {
      if (col.field) {
        acc[col.field] = { value: "", matchMode: "startsWith" }; // Ensure correct structure
      }
      return acc;
    }, {} as Record<string, { value: string; matchMode: string }>),
  );


  const [userOptions, setuserOptions] = useState<{ id: number; name: string }[]>([]);



  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await getUsersMasterDataList(PAGESTART, PAGESEND, {}); // Provide default values
        if (response.status.code === 200) {
          setuserOptions(response.data.map(userIds => ({
            id: userIds.user_id,
            name: userIds.name ?? "", // default to empty string if null
          })));


        } else {
          setuserOptions([]);
          CustomMessage(response.status.message, "error", enqueueSnackbar);
        }
      } catch (error: any) {
        CustomMessage(error.message, "error", enqueueSnackbar);
      }
    };

    fetchUser();
  }, []);


  const handleEditFamilyAsset = async (projectId: number) => {
    dispatch(setLoading(true));
    try {
      const response = await getProjectById(projectId);
      let { data, status } = response;
      if (status.code === 200 && data) {
        setProjectData({
          projectId: data.projectId,
          projectName: data.projectName,
          userIds: data.userIds,
          status: data.status, // <-- mapping here
        });
        setOpenDialog(true);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };



  const onFetchData = async (page: number, rows: number, filter?: Record<string, any>) => {
    dispatch(setLoading(true));
    try {
      const { data, status, pagination } = await getProjectMasterDataList(page, rows, filter ?? filterData);
      if (status.code === 200 && data?.length > 0) {
        setData(data);
        setPagination({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,
        });
      } else {
        setData([]);
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    setProjectData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClear = () => {
    setOpenDialog(false);
    setProjectData({
      projectId: 0,
      projectName: "",
      status: "",

      userIds: []
    });
  };


  const handleSubmit = async (event: React.FormEvent) => {
    event?.preventDefault();
    if (projectData.projectName === "") {
      CustomMessage("Add the name", "error", enqueueSnackbar);
      return;
    }
    dispatch(setLoading(true));
    try {
      const response = await saveProject(projectData);
      let { status } = response;
      if (status.code === 200 || status.code === 201) {
        CustomMessage(status.message, "success", enqueueSnackbar);
        handleClear();
        onFetchData(PAGESTART, PAGESEND, filterData);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };
  const userDetails = useSelector((state: RootState) => state.auth)

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {userDetails.role.some(
          r => r.roleName === "Admin" || r.roleName === "Masters List Write"
        ) && (
            <Chip
              className="btn-black-outlined mb-3"
              label="New"
              color="warning"
              onClick={() => setOpenDialog(true)}
              icon={<AddIcon />}
              variant="outlined"
            />
          )}
      </div>
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          borderRadius: 3,
          boxShadow: 3,
          padding: 2,
        }}
      >
        <ReusableDataTable
          data={data}
          columns={columns}
          onFetchData={onFetchData}
          emptyMessage="No data found."
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          selectionMode="multiple"
          rowsPerPageOptions={[5, 10, 25, 50]}
          pagination={pagination}
          setPagination={setPagination}
          filters={filterData}
          setFilters={setFilterData}
          onRowDoubleClick={(rowData) => {
            console.log('Double-click row:', rowData);
            handleEditFamilyAsset(rowData.projectId);
          }}
        />
      </Box>
      <ReusablePrimeReactDialog
        header="Add Project"
        visible={openDialog}
        onHide={handleClear}
        //allowedRoles={["Admin", "Master List Write"]}
        style={{ overflow: 'visible', zIndex: 1100 }}
        contentStyle={{ overflow: 'visible' }}
      >

        <form
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault(); // 🔒 prevent form submission
            }
          }}
        >
          <div className="mb-3">
            <h6>Project</h6>
            <TextField
              label=""
              fullWidth
              variant="outlined"
              value={projectData.projectName}
              name="projectName"
              onChange={handleChange}
              sx={{ mt: 0 }}
              required
            />
          </div>


          <Box sx={{ mt: 2, mb: 1, fontWeight: "bold", position: "relative" }}>
            <Typography variant="body1" sx={{ mt: 2, mb: 0, fontWeight: "bold" }}>
              Select User
            </Typography>
            <MultiSelect
              value={projectData.userIds}
              options={userOptions}
              optionLabel="name"
              optionValue="id"
              placeholder="Select User"
              appendTo="self"
              style={{ width: "100%" }}
              filter
              onChange={(e: MultiSelectChangeEvent) =>
                setProjectData((prev) => ({
                  ...prev,
                  userIds: e.value as number[],
                }))
              }
            />
          </Box>
          <Box sx={{ mt: 2, mb: 1, fontWeight: "bold", position: "relative" }}>
            <Typography variant="body1" sx={{ mt: 2, mb: 0, fontWeight: "bold" }}>
              Select Status
            </Typography>
            <MultiSelect
              value={projectData.status ? [projectData.status] : []}
              options={[
                { label: "Started", value: "started" },
                { label: "Completed", value: "completed" },
              ]}
              optionLabel="label"
              optionValue="value"
              placeholder="Select Status"
              display="chip"
              appendTo="self"
              style={{ width: "100%" }}
              panelStyle={{ zIndex: 9999 }}
              onChange={(e: MultiSelectChangeEvent) => {
                const selected = e.value;
                // Force only one selection
                const lastSelected = selected.length > 1 ? selected.slice(-1) : selected;
                setProjectData((prev) => ({
                  ...prev,
                  status: lastSelected[0] ?? null,
                }));
              }}
              selectedItemsLabel="" // hide extra selected count
            />

          </Box>






          {/* Buttons */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "30px" }}>
            <ReusablePrimeButton
              onClick={handleClear}
              severity="contrast"
              title="Cancel"
              type="button"
            >
              Cancel
            </ReusablePrimeButton>
            <ReusablePrimeButton className="ms-1" severity="info" onClick={handleSubmit} allowedRoles={["Admin", "Masters List Write"]}>
              Submit
            </ReusablePrimeButton>
          </div>
        </form>
      </ReusablePrimeReactDialog>

    </>
  );
};

export default Project;

